import { createFileRoute, redirect } from "@tanstack/react-router";
import { legacyUploadTarget } from "@/lib/legacy-uploads";

export const Route = createFileRoute("/wp-content/$")({
  beforeLoad: ({ params }) => {
    const legacyPath = params._splat?.replace(/^\/+/, "") ?? "";
    throw redirect({
      href: legacyUploadTarget(legacyPath),
      statusCode: 301,
      replace: true,
    });
  },
});
